<template>
  <div class="menu-main">
    <el-menu
        class="el-menu-vertical-demo"
        :collapse="getIsOpenCloseMenu"
        background-color="#f8fbff"
        text-color="#5f6f8f"
        active-text-color="#2f436d"
        :unique-opened="true"
    >
      <router-link to="/dashboard" class="router-link">
        <el-menu-item index="1" class="menu-logo-item">
          <i class="el-icon-s-home menu-logo-icon"></i>
          <span slot="title" class="onekids-title">ONEKIDS PARENT</span>
        </el-menu-item>
      </router-link>

      <router-link to="/parent/dashboard" class="router-link">
        <el-menu-item
            index="2"
            @click="changeBreadcrumbMethod('parent-dashboard')"
        >
          <i class="el-icon-s-data"/>
          <span>Biểu đồ</span>
        </el-menu-item>
      </router-link>

      <el-submenu index="3" class="menu-group-news">
        <template #title>
          <i class="el-icon-document"/>
          <span>Bản tin</span>
        </template>
        <router-link to="/parent/notify" class="router-link">
          <el-menu-item
              index="3-1"
              @click="changeBreadcrumbMethod('parent-notify')"
          >Thông báo
          </el-menu-item
          >
        </router-link>
        <router-link to="/parent/news" class="router-link">
          <el-menu-item
              index="3-2"
              @click="changeBreadcrumbMethod('parent-news')"
          >Tin tức nhà trường
          </el-menu-item
          >
        </router-link>
      </el-submenu>
      <el-submenu index="4" class="menu-group-activity">
        <template #title>
          <i class="el-icon-notebook-1"/>
          <span>Hoạt động</span>
        </template>
        <router-link to="/parent/album" class="router-link">
          <el-menu-item
              index="4-1"
              @click="changeBreadcrumbMethod('parent-album')"
          >Album ảnh
          </el-menu-item
          >
        </router-link>
        <router-link to="/parent/video" class="router-link">
          <el-menu-item
              index="4-2"
              @click="changeBreadcrumbMethod('parent-video')"
          >Video
          </el-menu-item
          >
        </router-link>
        <router-link to="/parent/video/other" class="router-link">
          <el-menu-item
              index="5-3"
              @click="changeBreadcrumbMethod('parent-video-other')"
          >Thư viện
          </el-menu-item
          >
        </router-link>
      </el-submenu>

      <el-submenu index="5" class="menu-group-support">
        <template #title>
          <i class="el-icon-question"/>
          <span>Hỗ trợ &amp; hướng dẫn</span>
        </template>
        <a
            v-for="item in supportList"
            :key="item.name"
            class="router-link"
            :href="item.link"
            target="_blank"
            style="display: block"
        >
          <el-menu-item :index="item.name">{{ item.name }}</el-menu-item>
        </a>
      </el-submenu>
    </el-menu>
  </div>
</template>
<script>
import {mapGetters} from "vuex";

export default {
  name: 'MenuParent',
  data() {
    return {
      breadcrumbDataList: [

        {
          key: "parent-dashboard",
          value: [{url: "/parent/dashboard", name: "Biểu đồ học sinh"}],
        },
        {
          key: "parent-notify",
          value: [{url: "/parent/notify", name: "Thông báo"}],
        },
        {
          key: "parent-news",
          value: [{url: "/parent/news", name: "Tin tức nhà trường"}],
        },
        {
          key: "parent-album",
          value: [{url: "/parent/album", name: "Album ảnh"}],
        },
        {
          key: "parent-video",
          value: [{url: "/parent/video", name: "Video"}],
        },
        {
          key: "parent-video-other",
          value: [{url: "/parent/video/other", name: "Thư viện"}],
        },
        {
          key: "school-permission-manage",
          value: [{url: "/school/permission-manage", name: "Quản lý quyền"}],
        },]
    }

  },
  created() {
    this.$store.dispatch('commonDataStore/fetchDataSupportList');
  },
  computed: {
    getIsOpenCloseMenu() {
      return this.$store.getters["layout/getIsOpenClose"];
    },
    getAppTypeUserLogin() {
      return this.$store.state.auth.user.appType;
    },
    ...mapGetters('commonDataStore',['supportList']),
  },
  methods: {
    changeBreadcrumbMethod(val) {
      let selectUrl = this.breadcrumbDataList.filter((x) => x.key === val);
      if (selectUrl.length === 1) {
        let dataList = selectUrl[0].value;
        sessionStorage.setItem("breadcrumbList", JSON.stringify(dataList));
        this.$store.dispatch("layout/setBreadcrumbActions", dataList);
        console.log(sessionStorage)
      }
    },
  },

}
</script>
<style lang="scss" scoped>
.menu-main {
  min-height: 950px;
  padding: 10px 12px 16px;
  background:
      radial-gradient(circle at top left, rgba(157, 197, 255, 0.28), transparent 28%),
      radial-gradient(circle at 100% 12%, rgba(255, 196, 214, 0.22), transparent 24%),
      linear-gradient(180deg, #f9fbff 0%, #f3f7ff 52%, #eef4fb 100%);
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 210px;
  min-height: 700px;
  font-family: Arial, sans-serif;
  border-right: none !important;
  border-radius: 18px;
  overflow: hidden;
}

/deep/ .el-menu--collapse {
  border-radius: 18px;
  overflow: hidden;
}

.router-link {
  text-decoration: none;
}

.el-menu-item.menu-logo-item {
  background: linear-gradient(135deg, #eef2ff 0%, #e3efff 52%, #f5e8ff 100%) !important;
  border-bottom: 1px solid #d7e3ff !important;
  height: 60px !important;
  line-height: normal !important;
  margin-bottom: 6px;
  padding: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;

  &:hover {
    background: linear-gradient(135deg, #e8f0ff 0%, #dbebff 50%, #f0e4ff 100%) !important;
    border-left-color: transparent !important;
  }
}

.menu-logo-icon {
  color: #5b7fd8 !important;
  font-size: 20px !important;
  background: linear-gradient(135deg, rgba(91, 127, 216, 0.16), rgba(173, 114, 255, 0.14));
  width: 30px;
  height: 30px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
}

/deep/ .el-menu--collapse .menu-logo-icon {
  margin-right: 0 !important;
}

.el-menu-item {
  background-color: transparent !important;
  height: 40px !important;
  line-height: 40px !important;
  font-size: 14px !important;
  color: #6c7b98 !important;
  border-left: 3px solid transparent !important;
  padding-left: 46px !important;
  border-radius: 10px !important;
  margin: 2px 8px !important;
  transition: all 0.22s ease;

  &:hover {
    background: linear-gradient(90deg, var(--menu-item-hover-start, #f2f7ff) 0%, var(--menu-item-hover-end, #eaf1ff) 100%) !important;
    color: #324b78 !important;
    border-left-color: var(--menu-accent, #7aa8ff) !important;
  }

  &.is-active {
    background: linear-gradient(90deg, var(--menu-active-start, #dfeaff) 0%, var(--menu-active-end, #d4e2ff) 100%) !important;
    color: #29456f !important;
    border-left: 3px solid var(--menu-accent-strong, #5d83dd) !important;
    font-weight: 600;
    box-shadow: inset 0 0 0 1px var(--menu-accent-border, rgba(93, 131, 221, 0.12));
  }
}

/deep/ .el-submenu__title {
  height: 48px !important;
  line-height: 48px !important;
  font-size: 14px !important;
  font-weight: 600;
  color: #5f6f8f !important;
  border-left: 3px solid transparent;
  border-radius: 12px;
  margin: 4px 8px;
  transition: all 0.25s ease;

  i {
    color: var(--menu-accent, #7e91b2) !important;
    font-size: 15px;
    margin-right: 8px;
    transition: color 0.2s ease;
  }

  > i:first-child {
    width: 28px;
    height: 28px;
    border-radius: 10px;
    margin-right: 10px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: var(--menu-accent-soft, rgba(93, 131, 221, 0.12));
    box-shadow: inset 0 0 0 1px var(--menu-accent-border, rgba(93, 131, 221, 0.14));
  }

  &:hover {
    background: linear-gradient(90deg, var(--menu-hover-start, #eff5ff) 0%, var(--menu-hover-end, #e8f0ff) 100%) !important;
    color: #324b78 !important;
    border-left-color: var(--menu-accent, #7aa8ff) !important;

    i {
      color: var(--menu-accent-strong, #5d83dd) !important;
    }
  }
}

/deep/ .el-submenu.is-opened > .el-submenu__title {
  background: linear-gradient(90deg, var(--menu-open-start, #edf4ff) 0%, var(--menu-open-end, #e5efff) 100%) !important;
  color: #2f436d !important;
  border-left: 3px solid var(--menu-accent, #6d96f5) !important;

  i {
    color: var(--menu-accent-strong, #5d83dd) !important;
  }
}

/deep/ .el-submenu__icon-arrow {
  color: #8b9aba !important;
  font-size: 11px;
  right: 12px;
}

/deep/ .el-message-box {
  display: inline-block;
  vertical-align: top !important;
  width: 420px;
  padding-bottom: 10px;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  font-size: 18px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  text-align: left;
  overflow: hidden;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

/deep/ .el-message-box__wrapper::after {
  content: "";
  display: inline-block;
  height: 100%;
  width: 0;
  vertical-align: top !important;
}

.el-menu {
  margin-bottom: 20px;
  border: 1px solid #e2eaf7 !important;
  box-shadow: 0 10px 30px rgba(65, 84, 118, 0.08);
  background: rgba(255, 255, 255, 0.82) !important;
  backdrop-filter: blur(6px);
}

.onekids-title {
  font-weight: 700;
  font-size: 15px;
  letter-spacing: 1.2px;
  color: #2f436d !important;
  text-transform: uppercase;
}

.menu-group-news {
  --menu-accent: #6f8cff;
  --menu-accent-strong: #5574e8;
  --menu-accent-soft: rgba(111, 140, 255, 0.16);
  --menu-accent-border: rgba(111, 140, 255, 0.18);
  --menu-hover-start: #f2f5ff;
  --menu-hover-end: #ebefff;
  --menu-open-start: #edf2ff;
  --menu-open-end: #e6edff;
  --menu-item-hover-start: #f3f6ff;
  --menu-item-hover-end: #edf1ff;
  --menu-active-start: #e3ebff;
  --menu-active-end: #dbe5ff;
}

.menu-group-activity {
  --menu-accent: #ff9f43;
  --menu-accent-strong: #f08a20;
  --menu-accent-soft: rgba(255, 159, 67, 0.16);
  --menu-accent-border: rgba(255, 159, 67, 0.2);
  --menu-hover-start: #fff7ee;
  --menu-hover-end: #ffefdf;
  --menu-open-start: #fff2e4;
  --menu-open-end: #ffe8d0;
  --menu-item-hover-start: #fff7ee;
  --menu-item-hover-end: #ffefdf;
  --menu-active-start: #ffeccf;
  --menu-active-end: #ffe2bb;
}

.menu-group-support {
  --menu-accent: #4bb6c9;
  --menu-accent-strong: #2a9dad;
  --menu-accent-soft: rgba(75, 182, 201, 0.16);
  --menu-accent-border: rgba(75, 182, 201, 0.18);
  --menu-hover-start: #eefbfd;
  --menu-hover-end: #e3f7fa;
  --menu-open-start: #e6f7fb;
  --menu-open-end: #d9f2f7;
  --menu-item-hover-start: #eefbfd;
  --menu-item-hover-end: #e2f6fa;
  --menu-active-start: #d8f0f5;
  --menu-active-end: #caebf2;
}

@media (max-width: 1200px) {
  .menu-main {
    padding: 8px;
  }
}
</style>
